import { faHeart } from '@fortawesome/free-solid-svg-icons'
const [ size,,,, heart ] = faHeart.icon

const NUM_CONFETTI = 350

const range = (a, b) => (b - a) * Math.random() + a

class Confetti {
  constructor ({ canvas, colors }) {
    this.canvas = canvas
    this.style = colors[~~range(0, colors.length)]
    this.r = ~~range(2, 6)
    this.r2 = 2 * this.r
    this.scale = this.r / 60
    this.xmin = -this.scale * size
    this.xmax = this.canvas.width - this.r
    this.ymax = this.canvas.height - this.r
    this.replace()
  }

  replace () {
    this.opacity = 0
    this.dop = 0.03 * range(1, 4)
    this.x = range(-this.r2, this.canvas.width - this.r2)
    this.y = range(-20, this.canvas.height - this.r2)
    this.vx = range(0, 2) + 8 * this.canvas.xpos - 5
    this.vy = 0.7 * this.r + range(-1, 1)
  }

  draw () {
    this.x += this.vx
    this.y += this.vy
    this.opacity += this.dop
    if (this.opacity > 1) {
      this.opacity = 1
      this.dop *= -1
    }
    if (this.opacity < 0 || this.y > this.ymax)
      this.replace()
    if (this.xmin > this.x)
      this.x = this.xmax
    else if (this.x > this.xmax)
      this.x = this.xmin
  }
}

export const init = (canvas, { colors }) => {
  const context = canvas.getContext('2d')
  let running = true

  canvas.xpos = 0.5
  const handleMouseMove = e => {
    if (e.pageX >= canvas.offsetLeft && e.pageX <= canvas.offsetLeft + canvas.width)
      canvas.xpos = (e.pageX - canvas.offsetLeft) / canvas.width
  }
  document.addEventListener('mousemove', handleMouseMove)

  const handleResize = () => {
    if (canvas.width == canvas.offsetWidth && canvas.height == canvas.offsetHeight)
      return

    canvas.width = canvas.offsetWidth
    canvas.height = canvas.offsetHeight
  }
  handleResize()
  const resizeObserver = new ResizeObserver(handleResize)
  resizeObserver.observe(canvas)

  const drawCircle = circle => {
    circle.draw()
    const path = new Path2D(heart)
    context.translate(~~circle.x, ~~circle.y)
    context.scale(circle.scale, circle.scale)
    context.fillStyle = `rgba(${circle.style.concat(circle.opacity).join()})`
    context.fill(path)
    context.setTransform(1, 0, 0, 1, 0, 0)
  }

  const step = () => {
    context.clearRect(0, 0, canvas.width, canvas.height)
    if (running) {
      confetti.forEach(drawCircle)
      requestAnimationFrame(step)
    }
  }

  const confetti = []
  for (let i = 1; i <= NUM_CONFETTI; i++) {
    confetti.push(new Confetti({ canvas, colors }))
  }
  step()

  return () => {
    running = false
    document.removeEventListener('mousemove', handleMouseMove)
    resizeObserver.disconnect()
  }
}

